<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form  size="small" ref='JZForm' label-width="90px" @search="handleSearch" @reset='handleReset' class="content_block">
            <el-form-item label="商品编码sku">
              <el-input v-model.trim="JZForm.sku"  placeholder="请输入商品编码"></el-input>
            </el-form-item>
            <el-form-item label="客户商品编码sku" label-width="130px">
              <el-input v-model.trim="JZForm.goodsCode"  placeholder="请输入商品编码"></el-input>
            </el-form-item>
            <el-form-item label="我方商品编码" label-width="110px">
              <el-input v-model.trim="JZForm.ourGoodsCode"  placeholder="请输入我方商品编码"></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
              <el-input v-model.trim="JZForm.name"  placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="型号">
              <el-input v-model.trim="JZForm.model"  placeholder="请输入型号"></el-input>
            </el-form-item>
            <el-form-item label="规格">
              <el-input v-model.trim="JZForm.specification"  placeholder="请输入规格"></el-input>
            </el-form-item>
            <el-form-item label="品牌">
              <el-input v-model.trim="JZForm.brandName"  placeholder="请输入品牌"></el-input>
            </el-form-item>
            <el-form-item label="生产商">
              <el-input v-model.trim="JZForm.enterpriseName"  placeholder="请输入生产商"></el-input>
            </el-form-item>
            <el-form-item label="厂家编码">
              <el-input v-model.trim="JZForm.factoryCode"  placeholder="请输入厂家编码"></el-input>
            </el-form-item>
            <el-form-item label="是否医疗件">
              <el-select v-model.trim="JZForm.medicalFlag" @change="handleSearch">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="医疗件" :value="true"></el-option>
                <el-option label="非医疗件" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :enableRowSelection="true"
            :scroll="{ x: '100%', y: isFullScreen ? '70vh' : scrollHeight }"
            rowKey="id"
            :selectedRowKeys="selectedKeys"
            @change="handleSelectionChange"
            @refresh="handleReset"
            @fullScreen="handleFullScreen">
            <template #buttons>
              <el-button v-if="$withPermission('gongxutong:vis:goods:changeInventory')" type="primary" size="mini" icon="el-icon-plus" :disabled="!selectedLists.length" @click="inventoryAdjustment">调库存</el-button>
              <el-button v-if="$withPermission('gongxutong:vis:goods:export')" type="primary" size="mini" :disabled="!total" @click="exportTable">导出</el-button>
            </template>
            <template slot="productCode" slot-scope="text, record">
              <span>{{ text || '--' }}</span>
              <!-- 小紫中台商品（无平台 skuId）可维护我方商品编码 -->
              <a v-if="!record.skuId" style="margin-left: 8px" @click="editProductCode(record)">编辑</a>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="product" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
          </xz-table>
        </div>
      </div>
      <div class="pagination-wrapper">
        <a-pagination
          :current="pagination.pageNum"
          :total="total"
          :show-total="total => `共 ${total || 0} 条`"
          show-size-changer
          :pageSizeOptions="['10', '20', '30', '50', '100']"
          show-quick-jumper
          :pageSize.sync="pagination.pageSize"
          @change="handleNumChange"
          @showSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <div class="button-wrapper">
      <el-button @click="handleBack">返回</el-button>
    </div>
    <BatchPriceAdjustment @handleSearch='resetHandleSearch' ref="batchPriceAdjustment"></BatchPriceAdjustment>
  </div>
</template>

<script>
import * as Moment from 'dayjs';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import { getSupplierGoodsPageList, exportSupplierGoodsPageList, saveCustomerGoodsMapping } from '@/api/userCenter';
import BatchPriceAdjustment from './components/batchPriceAdjustment';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';

const COMMON_COLUMNS = [
  {
    title: '商品编码(sku)',
    dataIndex: 'sku',
    key: 'sku',
    width: 130,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '客户商品编码(sku)',
    dataIndex: 'goodsCode',
    key: 'goodsCode',
    width: 180,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '我方商品编码',
    dataIndex: 'productCode',
    key: 'productCode',
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: 'productCode' },
  },
  {
    ellipsis: true,
    title: '商品名称',
    width: 150,
    dataIndex: 'name',
    key: 'name',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '型号',
    width: 150,
    dataIndex: 'model',
    key: 'model',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '规格',
    width: 150,
    dataIndex: 'specification',
    key: 'specification',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '所属品牌',
    width: 150,
    dataIndex: 'brandName',
    key: 'brandName',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '销售单价',
    width: 120,
    dataIndex: 'purchasePrice',
    key: 'purchasePrice',
    customRender: text => {
      return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2});
    },
  },
  {
    ellipsis: true,
    title: '库存数量',
    width: 100,
    dataIndex: 'stock',
    key: 'stock',
    customRender: (text, row) => {
      return text === '' || text === null || text === undefined ? '--' : `${text}${row.unitName || ''}`;
    },
  },
  {
    ellipsis: true,
    title: '生产商',
    width: 180,
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '厂家编码',
    width: 150,
    dataIndex: 'factoryCode',
    key: 'factoryCode',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '保修期',
    width: 100,
    dataIndex: 'period',
    key: 'period',
    customRender: (text, row) => {
      let period = text ? `${row.period}${row.periodUnit}` : '--';
      return period;
    },
  },
  {
    ellipsis: true,
    title: '是否医疗件',
    width: 120,
    dataIndex: 'medicalFlag',
    key: 'medicalFlag',
    customRender: (text) => {
      return text === true ? '是' : text === false ? '否' : '--';
    },
  },
  {
    ellipsis: true,
    title: '产品注册证/备案凭证',
    width: 150,
    dataIndex: 'registerCode',
    key: 'registerCode',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '上架状态',
    width: 100,
    dataIndex: 'status',
    key: 'status',
    customRender: (text) => {
      return text === 'UP' ? '上架' : text === 'DOWN' ? '下架' : '--';
    },
  },
  {
    ellipsis: true,
    title: '上架渠道',
    width: 150,
    dataIndex: 'expiryTime',
    key: 'expiryTime',
    customRender: () => {
      return '小紫供应链';
    },
  },
  {
    ellipsis: true,
    title: '更新时间',
    width: 180,
    dataIndex: 'lastUpdateTime',
    key: 'lastUpdateTime',
    customRender: (text) => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
];

export default {
  name: 'Product',
  components: {
    xzTable,
    tableHeaderConfiguration,
    BatchPriceAdjustment,
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
    // 对接系统：由商品对接页带入，为空时按进销存查询
    dockingSystem () {
      return this.$route.query.dockingSystem || '';
    },
  },
  created () {
    this.getList();
  },
  methods: {
    handleBack () {
      this.$router.back();
    },
    updateColumnList (columnList) {
      this.columnList = [...columnList];
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    resetHandleSearch () {
      this.selectedKeys = [];
      this.selectedLists = [];
      this.handleSearch();
    },
    handleSearch () {
      this.pagination.pageNum = 1;
      this.getList();
    },
    getList () {
      let currentParams = {
        pageFlag: true,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        ...this.JZForm,
        status: 'UP',
        dockingSystem: this.dockingSystem,
      };
      currentParams.orderBy = [{
        orderByProperty: 'createTime',
        orderByType: 'DESC',
      }];
      getSupplierGoodsPageList(currentParams).then((res) => {
        this.dataList = res.body.list;
        this.total = res.body.total;
      });
    },
    inventoryAdjustment () {
      // 小紫中台商品无平台 skuId，传中台供应商商品记录 id
      let idLists = this.selectedLists.map(item => item.skuId || item.id);
      this.$refs.batchPriceAdjustment.idLists = idLists;
      this.$refs.batchPriceAdjustment.dockingSystem = this.dockingSystem;
      this.$refs.batchPriceAdjustment.initPage();
    },
    exportTable () {
      let currentParams = {
        pageFlag: true,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize > 100 ? 100 : this.pagination.pageSize,
        ...this.JZForm,
        status: 'UP',
        dockingSystem: this.dockingSystem,
      };
      currentParams.orderBy = [{
        orderByProperty: 'createTime',
        orderByType: 'DESC',
      }];
      exportSupplierGoodsPageList(currentParams).then(({data})=>{
        const downloadData = {
          data: data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileTitle: `上架商品_${Date.now()}`,
        };
        this.downBinaryStreamHandle(downloadData);
      });
    },
    editProductCode (record) {
      this.$prompt(`客户商品编码：${record.goodsCode || '--'}，商品名称：${record.name || '--'}`, '编辑我方商品编码', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputValue: record.productCode,
        inputPlaceholder: '请输入我方商品编码',
        inputValidator: value => !value || value.length <= 100 || '不能超过100个字符',
      }).then(({ value }) => {
        saveCustomerGoodsMapping({
          dockingSystem: 'XIAOZI_MIDDLE',
          customerGoodsId: String(record.id),
          customerGoodsCode: record.goodsCode,
          customerGoodsName: record.name,
          goodsCode: value,
        }).then(() => {
          this.$message.success('保存成功');
          this.getList();
        });
      }).catch(() => {});
    },
    handleSelectionChange (keys, rows) {
      this.selectedKeys = keys;
      this.selectedLists = rows || [];
    },
    handleReset () {
      this.JZForm = {
        sku: '',
        goodsCode: '',
        ourGoodsCode: '',
        name: '',
        specification: '',
        model: '',
        brandName: '',
        customerName: '',
        medicalFlag: null,
        enterpriseName: '',
        factoryCode: '',
      };
      this.handleSearch();
    },
    downBinaryStreamHandle ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  data () {
    return {
      disabledList: ['goodsCode', 'name', 'brandName'],
      JZForm: {
        sku: '',
        goodsCode: '',
        ourGoodsCode: '',
        name: '',
        specification: '',
        model: '',
        brandName: '',
        customerName: '',
        medicalFlag: null,
        enterpriseName: '',
        factoryCode: '',
      },
      selectedKeys: [],
      selectedLists: [],
      dataList: [],
      columnList: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [
        ...COMMON_COLUMNS,
      ],
      scrollHeight: 'calc(100vh - 420px)',
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;

    .h-full {
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 15px 12px 0;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .button-wrapper {
    margin-top: 8px;
    padding: 0 16px;
    height: 60px;
    background-color: #fff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}
/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
